import { Button } from '@/components/ui/button';

interface QuestionNavigationProps {
  onBack: () => void;
  onNext: () => void;
  canProceed: boolean;
  isSubmitting: boolean;
  currentStep: number;
  totalQuestions: number;
  backDisabled: boolean;
  isLastStep?: boolean;
  isSharedMode?: boolean;
}

export function QuestionNavigation({
  onBack,
  onNext,
  canProceed,
  isSubmitting,
  currentStep,
  totalQuestions,
  backDisabled,
  isLastStep = false,
  isSharedMode = false,
}: QuestionNavigationProps) {
  const isFinalSharedStep =
    isSharedMode && (isLastStep || currentStep === totalQuestions - 1);

  return (
    <div className="flex flex-col gap-3 sm:flex-row sm:justify-between">
      <Button variant="outline" onClick={onBack} disabled={backDisabled}>
        Back
      </Button>

      {isFinalSharedStep ? (
        <p className="self-center text-sm text-muted-foreground">
          Changes save automatically.
        </p>
      ) : (
        <Button onClick={onNext} disabled={!canProceed || isSubmitting}>
          {isSubmitting ? (
            <>
              <span className="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent align-middle" />
              Submitting...
            </>
          ) : isLastStep || currentStep === totalQuestions - 1 ? (
            'Submit'
          ) : (
            'Next'
          )}
        </Button>
      )}
    </div>
  );
}
